import axios, { AxiosPromise } from 'axios'
import server from 'src/config/server'

const getBaseUrl = (isServer: boolean) =>
  isServer ? server.customisationBackendBaseUrl : '/api/fesc/v1/customisation'

export const getTheme = (params: {
  isServer: boolean
  siteId: string
}): AxiosPromise<Customisation.Theme> =>
  axios.get<Customisation.Theme>(`${getBaseUrl(params.isServer)}/theme`, {
    params: {
      siteId: params.siteId,
      v2: true
    }
  })

export const getPageData = (params: {
  slug: string
  isServer: boolean
  pageName: string
  siteId: string
}): AxiosPromise<Customisation.SectionSettingData> =>
  axios.get<Customisation.SectionSettingData>(
    `${getBaseUrl(params.isServer)}/page-data`,
    {
      params: {
        pageName: params.pageName,
        siteId: params.siteId,
        slug: params.slug
      }
    }
  )

export const getPreviewTheme = (params: {
  isServer: boolean
  previewToken: string
  menuId: string
}): AxiosPromise<Customisation.Theme> => axios.get<Customisation.Theme>(
  `${getBaseUrl(params.isServer)}/theme-preview`, {
    params: {
      menuId: params.menuId,
      previewToken: params.previewToken,
      v2: true
    }
  }
)

export const getPreviewPageData = (params: {
  slug: string
  isServer: boolean
  pageName: string
  siteId: string
}): AxiosPromise<Customisation.SectionSettingData> =>
  axios.get<Customisation.SectionSettingData>(
    `${getBaseUrl(params.isServer)}/page-data-preview`,
    {
      params: {
        pageName: params.pageName,
        siteId: params.siteId,
        slug: params.slug
      }
    }
  )
